module.exports = __webpack_public_path__ + "static/media/red-circle.7577a218.png";